export default {
  medical_coverage: 'medical_coverage',
  medical_training: 'medical_training',
  other: 'other',
}
